module.exports = __webpack_public_path__ + "static/media/clock_black.96643796.svg";